import { MessageCircle } from "lucide-react";

const WA_LINK = "https://wa.me/919135667888?text=Hi%20Jay%20Maa%20Sherawali%2C%20I%20need%20a%20moving%20quote.";

export const WhatsAppButton = () => (
  <a className="whatsapp-float" data-testid="whatsapp-float-button" href={WA_LINK} target="_blank" rel="noopener noreferrer" aria-label="Chat with us on WhatsApp">
    <MessageCircle size={24} />
  </a>
);
